var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInterestsOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_19438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0918 16.6666C2.0918 15.7826 2.35245 14.9347 2.8164 14.3096C3.28036 13.6845 3.90962 13.3333 4.56576 13.3333H17.9251",
    stroke: "#33A9A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56576 0.833313H17.9251V19.1666H4.56576C3.90962 19.1666 3.28036 18.8984 2.8164 18.4209C2.35245 17.9433 2.0918 17.2957 2.0918 16.6203V3.37961C2.0918 2.70429 2.35245 2.05663 2.8164 1.57911C3.28036 1.10158 3.90962 0.833313 4.56576 0.833313Z",
    stroke: "#33A9A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_19438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestsOn);
export default __webpack_public_path__ + "static/media/interests-on.c699445968b93bd1e3bfb1c9195a2a5e.svg";
export { ForwardRef as ReactComponent };